import styled from 'styled-components';
import theme from '../../styles/theme';

const Container = styled.div`
  background: ${theme.colors.neutral.bg.inverted};
  padding: ${theme.spacing['spacing-3']} ${theme.spacing['spacing-4']};
  border-radius: 16px;
`;

const Content = styled.div``;

const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spacing['spacing-3']};
`;

export { Container, Content, Head };
